import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, member, onConfirm, onCancel, isDeleting }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg shadow-deep max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-12 h-12 bg-error bg-opacity-10 rounded-full flex items-center justify-center">
              <Icon name="AlertTriangle" size={24} className="text-error" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">Delete Member</h3>
              <p className="text-sm text-muted-foreground">This action cannot be undone</p>
            </div>
          </div>

          {/* Content */}
          <div className="mb-6">
            <p className="text-foreground mb-3">
              Are you sure you want to delete the following member?
            </p>
            <div className="p-3 bg-muted rounded-lg border border-border">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="User" size={16} color="white" />
                </div>
                <div>
                  <p className="font-medium text-foreground">
                    {member?.firstName} {member?.lastName}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    ID: {member?.id} • CPF: {member?.cpf}
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-3 p-3 bg-error bg-opacity-5 border border-error border-opacity-20 rounded-lg">
              <div className="flex items-start space-x-2">
                <Icon name="AlertCircle" size={16} className="text-error mt-0.5" />
                <div className="text-sm">
                  <p className="text-error font-medium mb-1">Warning:</p>
                  <ul className="text-error space-y-1">
                    <li>• All member data will be permanently deleted</li>
                    <li>• This action cannot be reversed</li>
                    <li>• Member history will be lost</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center justify-end space-x-3">
            <Button
              variant="outline"
              onClick={onCancel}
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              loading={isDeleting}
              iconName="Trash2"
              iconPosition="left"
            >
              {isDeleting ? 'Deleting...' : 'Delete Member'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;